require('app/www/components/blocks/router.jsx')(
    require('app/www/components/controllers/Program/Program')
);
